<div class=`follow-heart-wrapper heartIcon ${data.isFollowing ? 'follow-heart-wrapper--followed': ''}` aria-label=data.ariaLabel>
    <div hidden>
        <svg>
            <symbol id="icon-save-small" viewBox="0 0 16 14">
                <path fill-rule="evenodd" d="M11.684 0c-.017 0 .017 0 0 0a4.236 4.236 0 00-3.022 1.267A6.93 6.93 0 008 2.084a6.826 6.826 0 00-.806-.966C6.44.366 5.383 0 4.31 0h-.05c-.934 0-1.87.272-2.591.865-2.152 1.767-2.142 4.708-.43 6.442l6.035 6.38a1.002 1.002 0 001.453 0l6.016-6.36A4.29 4.29 0 0011.708 0h-.024zm.009 1.5c.745 0 1.462.29 1.989.817a2.77 2.77 0 01.818 1.974c0 .746-.29 1.447-.847 2.004L8 12.271 2.306 6.252a2.798 2.798 0 01-.802-2.107c.042-.81.439-1.564 1.117-2.12.412-.339.994-.525 1.639-.525h.05c.727 0 1.392.248 1.825.68.232.231.445.486.63.756a1.498 1.498 0 002.47 0 5.33 5.33 0 01.502-.623 2.74 2.74 0 011.956-.813z"></path>
            </symbol>
        </svg>
        <svg>
            <symbol id="icon-save-selected-small" viewBox="0 0 16 14">
                <path d="M14.742 1.256A4.292 4.292 0 0011.66 0a4.18 4.18 0 00-2.998 1.267c-.24.255-.462.529-.66.818a6.86 6.86 0 00-.662-.818A4.182 4.182 0 004.34 0h-.035a4.291 4.291 0 00-3.068 7.308l6.036 6.38a1 1 0 001.453 0l6.015-6.36a4.292 4.292 0 000-6.072z"></path>
            </symbol>
        </svg>
    </div>
    <if(data.waiting)>
        <span class="progress-spinner" aria-label=data.txtBusy role="img"></span>
    </if>
    <else>
        <svg class=`follow-heart-icon icon icon--save${data.isFollowing ? '-selected' : ''}-small` focusable="false" height="16" width="16" aria-hidden=(!data.ariaLabel && 'true')>
            <use xlink:href=`#icon-save${data.isFollowing ? '-selected' : ''}-small`></use>
        </svg>
    </else>
</div>
